import { makeStyles } from '@mui/styles';
import { heading2 } from '../../../shared/theme/text.styles';

export const useOpeningsSectionStyles = makeStyles((theme) => ({
  osWrapper: {
    backgroundColor: theme.palette.background.main,
    padding: '100px 0',
  },

  title: {
    ...heading2,
    // color: 'white',
  },

  openings: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '70px',
    flexWrap: 'wrap',

    [theme.breakpoints.down('lg')]: {
      columnGap: '40px',
      rowGap: '40px',
    },
  },
}));
